class PdpToolbar extends HTMLElement {
  constructor() {
    super();

    this.isPddButtonVisible = false;

    this.pdpButtonElementWrap = document.querySelector(".product-form__buttons");
    this.pdpButtonElement = this.pdpButtonElementWrap?.querySelector(".product-form__submit");

    this.removeWhenActiveElementAll = this.querySelectorAll("[data-remove-element-when-active]");

    this.buttonElement = this.querySelector("[data-pdp-toolbar-button]");

    if (this.hasAttribute('data-adapt-purchase')) {
      this.setupAdaptedPurchase();
    } else {
      this.init();
    }
  }

  setupAdaptedPurchase() {
    this.productInfo = document.querySelector('product-info[data-ajax-content="pdp-info"]');
    if (!this.productInfo || !this.buttonElement) return;
    this.syncPurchase = () => {
      const submit = this.productInfo.querySelector('.product-form__submit');
      const enquiry = document.querySelector('#formContainer-Inline') || this.productInfo.querySelector('[data-enquire-form]');
      this.pdpButtonElement = submit;
      this.pdpButtonElementWrap = this.productInfo.querySelector('.product-form__buttons');
      this.chooseOptions = !!submit?.hasAttribute('data-select-option');
      this.enquireOnly = !submit || (!this.chooseOptions && (submit.disabled || getComputedStyle(submit).display === 'none'));
      this.purchaseTarget = this.enquireOnly ? enquiry : submit;
      const label = this.chooseOptions ? this.dataset.optionsLabel : this.enquireOnly ? this.dataset.enquiryLabel : submit?.querySelector('span')?.textContent.trim() || submit?.textContent.trim();
      if (label && this.buttonElement.textContent.trim() !== label) this.buttonElement.textContent = label;
      this.buttonElement.disabled = !this.purchaseTarget;
      if (this.pdpButtonElementWrap && this.observedWrap !== this.pdpButtonElementWrap) {
        this.purchaseIntersection.disconnect();
        this.purchaseIntersection.observe(this.pdpButtonElementWrap);
        this.observedWrap = this.pdpButtonElementWrap;
      }
    };
    this.purchaseIntersection = new IntersectionObserver(entries => {
      this.isPddButtonVisible = entries.some(entry => entry.isIntersecting);
      this.updateClass();
    });
    this.purchaseMutation = new MutationObserver(this.syncPurchase);
    this.purchaseMutation.observe(this.productInfo,{subtree:true,childList:true,characterData:true,attributes:true,attributeFilter:['disabled','style','data-select-option']});
    this.onPurchaseClick = () => {
      this.syncPurchase();
      if (this.chooseOptions) {
        const picker = this.productInfo.querySelector('.bj-variant-size-select-options,[data-variant-picker] select');
        this.productInfo.scrollIntoView({block:'center',behavior:'smooth'});
        picker?.focus({preventScroll:true});
      } else if (this.enquireOnly && this.purchaseTarget?.id === 'formContainer-Inline') {
        this.purchaseTarget.scrollIntoView({block:'center',behavior:'smooth'});
        this.purchaseTarget.querySelector('input[type="email"]')?.focus({preventScroll:true});
      } else if (this.purchaseTarget && !this.purchaseTarget.disabled) {
        this.purchaseTarget.click();
      }
    };
    this.buttonElement.addEventListener('click',this.onPurchaseClick);
    this.syncPurchase();
  }

  disconnectedCallback() {
    this.purchaseMutation?.disconnect();
    this.purchaseIntersection?.disconnect();
    if (this.onPurchaseClick) this.buttonElement?.removeEventListener('click',this.onPurchaseClick);
  }

  init() {
    if (!this.pdpButtonElementWrap) return;

    var intersectionObserver = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.intersectionRatio > 0) {
          this.isPddButtonVisible = true;
        } else {
          this.isPddButtonVisible = false;
        }

        this.updateClass();
      });
    });

    intersectionObserver.observe(this.pdpButtonElementWrap);

    if (this.buttonElement) {
      this.buttonElement.addEventListener("click", () => this.pdpButtonElement.click());
    }
  }

  updateClass() {
    if (!this.pdpButtonElementWrap) return;
    if (this.isPddButtonVisible) {
      this.classList.remove("is-active");
    } else {
      if (window.scrollY > this.pdpButtonElementWrap.offsetTop + this.pdpButtonElementWrap.offsetHeight) {
        this.classList.add("is-active");

        this.removeWhenActive();
      }
    }
  }

  removeWhenActive() {
    if (!this.removeWhenActiveElementAll.length) return;

    this.removeWhenActiveElementAll.forEach((element) => element.remove());
  }
}

customElements.define("pdp-toolbar", PdpToolbar);
